export enum AuditLogChangeType {
  UNKNOWN = 0,
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
}

export enum AuditLogEntrySourceType {
  UNKNOWN = 0,
  API = 'API',
  CAMPAIGN_MANAGER = 'CAMPAIGN_MANAGER',
  INTERNAL = 'INTERNAL',
}

export interface RawAuditLogEntryApiResponse {
  timestamp: string;
  from: string | null;
  to: string | null;
  type: AuditLogChangeType;
  resource_type: string;
  resource_id: string;
  user_id: string;
  user_email: string;
  source: AuditLogEntrySourceType;
}
